import React from 'react';
import { FormattedDate } from 'react-intl';

import { DATE_FORMAT } from 'utils/dateFormats';

type StandardDateProps = Pick<React.ComponentProps<typeof FormattedDate>, 'value'>;

const StandardDate: React.FC<StandardDateProps> = ({ value }) => (
  // eslint-disable-next-line no-restricted-syntax
  <FormattedDate value={value} {...DATE_FORMAT} />
);

export default StandardDate;